import { ChangeDetectionStrategy, Component, inject, OnInit, WritableSignal } from '@angular/core';
import { LucideAngularModule, User, LogOut } from 'lucide-angular';
import { LucideIconData } from 'lucide-angular/icons/types';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { WSDepartureService } from '../../../shared/services/ws-departure-service/implementations/ws-departure.service';
import { ThemeService } from '../../../shared/services/theme-service/theme.service';
import { NgClass } from '@angular/common';
import { NavbarHeightService } from '../../../shared/services/navbar-height-service/navbar-height.service';

@Component({
  selector: 'app-navbar',
  imports: [LucideAngularModule, RouterLink, RouterLinkActive, NgClass],
  standalone: true,
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly navbarService = inject(NavbarHeightService);
  protected readonly navbarHeight = this.navbarService.navbarHeight;
  private readonly wsDepartureService = inject(WSDepartureService);
  private readonly themeService = inject(ThemeService);
  protected readonly userIcon: LucideIconData = User;
  protected readonly logOutIcon: LucideIconData = LogOut;
  protected readonly window = window;
  protected userLogin = '';
  protected userInitial = '';
  protected pendingRequestsCount: WritableSignal<number> =
    this.wsDepartureService.pendingRequestsCount;

  ngOnInit(): void {
    this.getUserLogin();
    this.generateUserInitials();
    this.setNavbarHeight(50);
  }

  private getUserLogin(): void {
    this.userLogin = localStorage.getItem('rsUserLogin')!;
  }

  private generateUserInitials(): void {
    const cleanLogin = this.userLogin.split('@')[0].trim();

    if (cleanLogin.length === 0) {
      this.userInitial = '?';
      return;
    } else if (cleanLogin.length >= 5) {
      const firstSymbol = cleanLogin[0].toUpperCase();
      const lastSymbol = cleanLogin[cleanLogin.length - 1].toUpperCase();

      this.userInitial = firstSymbol + lastSymbol;
      return;
    } else {
      this.userInitial = cleanLogin[0].toUpperCase();
    }
  }

  protected changeTheme(theme: 'dark' | 'light'): void {
    this.themeService.changeTheme(theme);
  }

  private setNavbarHeight(height: number): void {
    this.navbarService.setValue(height);
  }

  protected logout(): void {
    localStorage.removeItem('rsToken');
    this.wsDepartureService.canConnectToCentrifugeController.next(false);
    this.wsDepartureService.unsubscribeCentrifuge();
    this.navbarService.setValue(50);

    this.router.navigate(['/auth']);
  }
}
